import React, { useState } from 'react'
import { getIn } from 'formik'
import { callEach } from '../../services/common'
import { TypeaheadSluglineOrigin } from '../TypeaheadSluglineOrigin'

export const CustomTypeheadSlugline = ({
  field,
  form,
  validateImmediately,
  changeValue,
  loadOptions,
  onChange,
  onBlur,
  disabled,
  label,
  placeholder,
  helperText,
  defaultValueAdornment,
}) => {
  const [changed, setChanged] = useState(false)
  const isNotValid =
    (changed || validateImmediately || getIn(form.touched, field.name)) &&
    !!getIn(form.errors, field.name)
  const handleSelect = (value: string): void => {
    form.setFieldValue(field.name, value)
  }
  return (
    <TypeaheadSluglineOrigin
      label={label}
      name={field.name}
      helperText={isNotValid ? getIn(form.errors, field.name) : helperText}
      loadOptions={loadOptions}
      error={isNotValid}
      onSelect={handleSelect}
      onBlur={callEach(field.onBlur, onBlur)}
      onChange={(e) => {
        setChanged(true)
        if (changeValue) {
          const { value, selectionStart } = e.target
          e.target.value = changeValue(value)
          e.target.selectionStart = selectionStart
          e.target.selectionEnd = selectionStart
        }
        if (onChange) {
          onChange(e)
        }
        field.onChange(e)
      }}
      value={field.value}
      disabled={disabled}
      placeholder={placeholder}
      defaultValueAdornment={defaultValueAdornment}
    />
  )
}
